import React from 'react';
import Page from '../components/Page';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Label,
  Row,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
  Table,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ButtonGroup,
} from 'reactstrap';
import axios from 'axios';
import StorageService from '../services/StorageService';
import {
  MdDone,
  MdClear,
  MdCreate,
  MdSearch,
  MdDelete,
  MdEdit,
} from 'react-icons/md';
import classnames from 'classnames';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import CrmAddressTable from '../components/CrmAddressTable';
import CrmCustomerDataTable from '../components/CrmCustomerDataTable';
import CrmCustomerForm from '../components/CrmCustomerForm';
import { IconContext } from 'react-icons/lib';
import { FaEdit } from 'react-icons/fa';

class CrmCustomerDetailPage extends React.Component {
  _isMounted = true;
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      remarkModal: false,
      redirect: false,
      isLoading: true,
      customerList: [],
      filteredList: [],
      searchKey: '',
      addressList: [],
      data: [],
      customer_id: this.props.match.params.id,
      categoryList: [],
      category: '',
      membership_id: '',
      company: '',
      name: '',
      email: '',
      contact: '',
      contact_person: '',
      tag: '',
      dnd: '',
      billing_address: '',
      billing_unit: '',
      billing_postal_code: '',
      billing_country: '',
      remarks: '',
      dob: '',
      selectedId: '',
      selectedData: '',
      deleteType: '',
      tabList: [{ name: 'Address' }, { name: 'Custom Data' }],
      activeTab: '1',
      edit_remarks: '',
      dnd: '',
    };
  }

  componentDidMount() {
    this.getCustomerDetail();
    this.getCategoryList();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }
  changeHandler = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  remarkModal = () => () => {
    return this.setState({
      remarkModal: !this.state.remarkModal,
      edit_remarks: this.state.remarks,
    });
  };

  checkboxChangeHandler = event => {
    this.setState({
      [event.target.name]: !this.state[event.target.name],
    });
    this.CustomerDND(!this.state[event.target.name]);
  };

  toggle = (action, id) => () => {
    return this.setState({
      modal: !this.state.modal,
      isEdit: action == 'EDIT' ? true : false,
    });
  };

  toggleConfirmModal = (name, id, type) => () => {
    return this.setState({
      confirmModal: !this.state.confirmModal,
      selectedData: name,
      selectedId: id,
      deleteType: type,
    });
  };

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    });

    this.setState({
      modal: false,
    });

    if (reload) {
      window.location.reload();
    } else {
      this.getCustomerDetail();
    }
  };

  CustomerDND(dnd) {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      customer_id: this.state.customer_id,
      dnd: dnd ? '1' : '0',
      updated_by: user.email,
    };
    axios
      .post(url + ':3004/v1/customer/detail/dnd', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        let message = this.state.followup
          ? 'Customer Do Not Disturb'
          : 'Customer Remove Do Not Disturb';
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: message,
          level: 'success',
          position: 'br',
          autoDismiss: 2,
          dismissible: 'click',
        });
        this.getCustomerDetail();
      })
      .catch(error => {
        alert(error);
      });
  }

  remarks = e => {
    e.preventDefault();
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      customer_id: this.state.customer_id,
      remarks: this.state.edit_remarks,
      updated_by: user.email,
    };

    axios
      .post(url + ':3004/v1/customer/detail/remark', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Remark updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        });
        this.setState({ remarkModal: false });
        this.getCustomerDetail();
      })
      .catch(error => {
        alert(error);
      });
  };

  getCategoryList = () => {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    };
    axios
      .post(url + ':3004/v1/customer/category', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        if (this._isMounted) {
          this.setState({
            categoryList: result.data,
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  delete = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_UNITY_API2_URL;

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      customer_id: this.state.customer_id,
      remove_by: user.email,
    };

    axios
      .post(url + ':3004/v1/customer/delete', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          });
          return;
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: `Customer deleted successfully.`,
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        });
        this.setState({ confirmModal: false });
        setTimeout(() => {
          this.props.history.push('/crmcustomer');
        }, 1000);
      })
      .catch(error => {
        alert(error);
      });
  };

  getCustomerDetail = () => {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      customer_id: this.state.customer_id,
    };

    axios
      .post(url + ':3004/v1/customer/detail', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }

        if (this._isMounted) {
          this.setState({
            category: result.data.category,
            membership_id: result.data.membership_id,
            company: result.data.company,
            name: result.data.name,
            email: result.data.email,
            contact: result.data.contact,
            contact_person: result.data.contact_person,
            tag: result.data.tag,
            billing_address: result.data.billing_address,
            billing_unit: result.data.billing_unit,
            billing_postal_code: result.data.billing_postal_code,
            billing_country: result.data.billing_country,
            dob: result.data.dob,
            remarks: result.data.remarks,
            addressList: result.data.address,
            data: result.data.data,
            dnd: result.data.dnd,
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  render() {
    const { activeTab } = this.state;

    return (
      <Page
        className="CrmCustomerDetailPage"
        title="Customer Detail"
        breadcrumbs={[
          { name: 'Customer', active: false, path: '/crmcustomer' },
          { name: 'Detail', active: true, path: '' },
        ]}
      >
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
        <Row>
          <Col>
            <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  name="dnd"
                  checked={this.state.dnd}
                  onChange={this.checkboxChangeHandler}
                />{' '}
                Do Not Disturb
              </Label>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display">
              <CardHeader className="d-flex align-items-center justify-content-between ps-bg-gradient">
                Customer Information
                <ButtonGroup>
                  <Button
                    className="theme-button theme-button-secondary"
                    onClick={this.toggle('EDIT', this.state.customer_id)}
                  >
                    <MdEdit />
                    Edit
                  </Button>
                  <Button
                    className="theme-button theme-button-secondary"
                    onClick={this.toggleConfirmModal(
                      this.state.name,
                      this.state.customer_id,
                      'Customer',
                    )}
                  >
                    <MdDelete />
                    Delete
                  </Button>
                </ButtonGroup>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col>
                    <Row form>
                      <Col lg={4}>
                        <Label>Category</Label>
                        <p>{this.state.category}</p>
                      </Col>
                      <Col lg={4}>
                        <Label>Membership ID</Label>
                        <p>{this.state.membership_id}</p>
                      </Col>
                      <Col lg={4}>
                        <Label>Name</Label>
                        <p>{this.state.name}</p>
                      </Col>
                      <Col lg={4}>
                        <Label>Company</Label>
                        <p>{this.state.company}</p>
                      </Col>
                      <Col lg={4}>
                        <Label>Contact</Label>
                        <p>{this.state.contact}</p>
                      </Col>
                      <Col lg={4}>
                        <Label>Contact Person</Label>
                        <p>{this.state.contact_person}</p>
                      </Col>
                      <Col lg={4}>
                        <Label>Email</Label>
                        <p>{this.state.email}</p>
                      </Col>
                      <Col lg={4}>
                        <Label>Billing Address</Label>
                        <p>{this.state.billing_address}</p>
                      </Col>
                      <Col lg={4}>
                        <Label>Billing Unit</Label>
                        <p>{this.state.billing_unit}</p>
                      </Col>
                      <Col lg={4}>
                        <Label>Billing Country</Label>
                        <p>{this.state.billing_country}</p>
                      </Col>
                      <Col lg={4}>
                        <Label>Billing Postal Code</Label>
                        <p>{this.state.billing_postal_code}</p>
                      </Col>
                      <Col lg={4}>
                        <Label>Date of Birth</Label>
                        <p>{this.state.dob}</p>
                      </Col>
                      <Col lg={4}>
                        <Label>Tag</Label>
                        <p>{this.state.tag}</p>
                      </Col>
                      {/* <Col lg={4}>
                        <Label>Remarks</Label>
                        <p>{this.state.remarks}</p>
                      </Col> */}
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display">
              <CardHeader className="ps-bg-gradient">
                Remark
                <Button
                  color="link"
                  style={{ padding: '2px 0px 7px 5px' }}
                  onClick={this.remarkModal()}
                >
                  <IconContext.Provider value={{ color: 'white' }}>
                    <FaEdit size={16} />
                  </IconContext.Provider>
                </Button>
              </CardHeader>
              <CardBody>
                <Row form>
                  <Col>
                    <p>{this.state.remarks ? this.state.remarks : 'None'}</p>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display main">
              <CardBody>
                <Nav tabs className="ps-tab">
                  {this.state.tabList.map((item, index) => {
                    return (
                      <NavItem key={item.name}>
                        <NavLink
                          className={classnames({
                            active: activeTab === (index + 1).toString(),
                          })}
                          onClick={() => {
                            this.toggleTab((index + 1).toString());
                          }}
                        >
                          {item.name}
                        </NavLink>
                      </NavItem>
                    );
                  })}
                </Nav>

                {this.state.customer_id && (
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="1" className="py-3">
                      <CrmAddressTable data={this.state} {...this.props} />
                    </TabPane>
                    <TabPane tabId="2" className="py-3">
                      <CrmCustomerDataTable data={this.state} {...this.props} />
                    </TabPane>
                  </TabContent>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal
          isOpen={this.state.modal}
          // toggle={this.toggle()}
          className="modal-lg"
          centered
        >
          <CrmCustomerForm
            history={this.props.history}
            onToggleModal={this.toggle}
            closeModal={this.closeModal}
            match={this.props.match}
            data={this.state}
          />
        </Modal>

        <Modal
          isOpen={this.state.confirmModal}
          toggle={this.toggleConfirmModal()}
          className={this.props.className}
          centered
          style={{ fontSize: '0.85rem' }}
        >
          <ModalHeader toggle={this.toggleConfirmModal()}>
            Delete Customer
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>
                  Are you sure you want to delete customer{' '}
                  {this.state.selectedData} ?
                </p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              className="theme-button theme-button-secondary"
              onClick={this.toggleConfirmModal()}
            >
              No
            </Button>
            <Button
              className="theme-button theme-button-primary"
              onClick={() =>
                this.state.deleteType === 'PriceMod'
                  ? this.deletePriceMod()
                  : this.delete()
              }
            >
              Yes
            </Button>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={this.state.remarkModal}
          // toggle={this.remarkModal()}
          className={this.props.className}
          centered
          style={{ fontSize: '0.85rem' }}
        >
          <Form onSubmit={this.remarks}>
            <ModalHeader toggle={this.remarkModal()}>Remark</ModalHeader>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Input
                      type="textarea"
                      name="edit_remarks"
                      value={this.state.edit_remarks}
                      rows={3}
                      onChange={this.changeHandler}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button
                className="theme-button theme-button-secondary"
                onClick={this.remarkModal()}
              >
                Close
              </Button>
              <Button
                className="theme-button theme-button-primary"
                type="submit"
              >
                Save
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
      </Page>
    );
  }
}

export default CrmCustomerDetailPage;
